import React from 'react'
import { Link, NavLink } from 'react-router-dom';
import '../Footer/Footer.css'
import LogoBlack from '../../Img/logo-2.png';
import { FaFacebookF, FaLinkedinIn, FaPhoneAlt, FaEnvelopeOpen, FaMapMarkerAlt } from 'react-icons/fa';
import { SiX } from "react-icons/si";


const Footer = () => {
    return (
        <div class="section footer-section footer-section-04">

            <div class="container">
                {/* <!-- Footer Widget Wrap Start --> */}
                <div class="footer-widget-wrap">
                    <div class="row">
                        <div class="col-lg-3 col-sm-6">
                            {/* <!-- Footer Widget Start --> */}
                            <div class="footer-widget-about">
                                <a class="footer-logo" href="index.html">
                                    <img src={LogoBlack} alt="Logo" />
                                </a>
                                <p>Accelerate innovation with world-class tech teams We’ll match you to an entire remote
                                    team of incredible freelance talent.</p>
                                <div class="footer-social">
                                    <ul class="social">
                                        <li><a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><FaFacebookF /></a></li>
                                        <li><a href="https://www.twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter"><SiX /></a></li>
                                        <li><a href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><FaLinkedinIn /></a></li>
                                    </ul>
                                </div>
                            </div>
                            {/* <!-- Footer Widget End --> */}
                        </div>
                        <div class="col-lg-3 col-sm-6">
                            {/* <!-- Footer Widget Start --> */}
                            <div class="footer-widget">
                                <h4 class="footer-widget-title">Useful Links</h4>

                                <div class="widget-link">
                                    <ul className="link">
                                        <li><Link to="/TermsAndCondition" aria-label="Terms and Conditions">Terms & Conditions</Link></li>
                                        <li><Link to="/PrivacyPolicy" aria-label="Privacy And Policy">Privacy And Policy</Link></li>
                                        <li><Link to="/refund_policy" aria-label="Refund Policy">Refund Policy</Link></li>
                                        {/* <li><Link to="/about-us" aria-label="About Company">About Company</Link></li> */}
                                        {/* <li><Link to="/payment-gateway" aria-label="Payment Gateway">Payment Gateway</Link></li> */}
                                    </ul>
                                    {/* <ul class="link">
                                        <li><a href="/terms-and-conditions" aria-label="Terms and Conditions">Terms & Conditions</a></li>
                                        <li><a href="/about-us" aria-label="About Company">About Company</a></li>
                                        <li><a href="/payment-gateway" aria-label="Payment Gateway">Payment Gateway</a></li>
                                        <li><a href="/privacy-policy" aria-label="Policy">Policy</a></li>
                                    </ul> */}
                                </div>
                            </div>
                            {/* <!-- Footer Widget End --> */}
                        </div>

                        <div class="col-lg-3 col-sm-6">
                            {/* <!-- Footer Widget Start --> */}
                            <div class="footer-widget">
                                <h4 class="footer-widget-title">Our Services</h4>

                                <div class="widget-link">
                                    <ul class="link">
                                        <li><NavLink to="/DShieldPro">DShield Pro</NavLink></li>
                                        <li><NavLink to="/DShieldProMax">DShield Pro Max</NavLink></li>
                                        <li><NavLink to="/Harsafe_Meet">Harsafe Meet</NavLink></li>
                                        <li><NavLink to="/HisabBook">Harsafe Meet Hisab Book</NavLink></li>
                                        <li><NavLink to="/Reels_Main">Harsafe Meet Reels</NavLink></li>
                                        {/* <li><NavLink to="/#">Harsafe Meet E-Commerce</NavLink></li> */}
                                        {/* <li><NavLink to="/#">Harsafe Meet Expence Management</NavLink></li> */}
                                    </ul>
                                </div>
                            </div>
                            {/* <!-- Footer Widget End --> */}
                        </div>
                        <div class="col-lg-3 col-sm-6">
                            {/* <!-- Footer Widget Start --> */}
                            <div class="footer-widget">
                                <h4 class="footer-widget-title">Company Information</h4>

                                <div class="widget-info">
                                    <ul>
                                        <li>
                                            <div className="info-icon">
                                                <FaPhoneAlt />
                                            </div>
                                            <div className="info-text">
                                                <span><a href="tel:+918003773959">+91 80037 73959</a></span>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="info-icon">
                                                <FaEnvelopeOpen />
                                            </div>
                                            <div className="info-text">
                                                <span><a href="mailto:info@harsafe.com">info@harsafe.com</a></span>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="info-icon">
                                                <FaMapMarkerAlt />
                                            </div>
                                            <div className="info-text">
                                                <span>Ward No.8, Srimadhopur Bazar, Srimadhopur, Sikar, Rajasthan, India, 332715</span>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            {/* <!-- Footer Widget End --> */}
                        </div>
                    </div>
                </div>
                {/* <!-- Footer Widget Wrap End --> */}

                {/* <!-- Footer Disclaimer Start --> */}
                <div class="footer-disclaimer">
                    <p>
                        <strong>Disclaimer:</strong> Harsafe Meet (HSMeet), including its Hisab Book feature, is a
                        record-keeping and communication tool only. HSMeet does not guarantee the accuracy,
                        completeness, or reliability of any financial records, entries, or data maintained by users
                        through the platform, and does not act as a bank, financial institution, payment processor,
                        or provider of financial, investment, or accounting advice. Users are solely responsible for
                        verifying and maintaining their own financial records. Please refer to our
                        {' '}<Link to="/TermsAndCondition" aria-label="Terms and Conditions">Terms & Conditions</Link>{' '}
                        for complete details.
                    </p>
                </div>
                {/* <!-- Footer Disclaimer End --> */}
            </div>

            {/* <!-- Footer Copyright Start --> */}
            <div class="footer-copyright-area">
                <div class="container">
                    <div class="footer-copyright-wrap">
                        <div class="row align-items-center">
                            <div class="col-lg-6">
                                {/* <!-- Footer Copyright Text Start --> */}
                                <div class="copyright-text text-end">
                                    <p>© Copyrights 2024 Harsafe Technology Finance Service Pvt. Ltd. All Rights Reserved. </p>
                                </div>
                            </div>
                            <div class="col-lg-3">
                                <div class="copyright-text text-end">
                                    <p>GST Number: <b>08AAHCH0668P1ZZ</b>  </p>
                                </div>
                                {/* <!-- Footer Copyright Text End --> */}
                            </div>
                            <div class="col-lg-3">
                                <div class="copyright-text text-end">
                                    <p>CIN Number: <b>U62013RJ2023PTC091109</b>  </p>
                                </div>
                                {/* <!-- Footer Copyright Text End --> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- Footer Copyright End --> */}
        </div>
    )
}

export default Footer